export default "__VITE_ASSET__9nU3cyMz__"